import styled from '@emotion/styled';
import { DialogProps, Drawer, DrawerProps } from '@fluentui/react-components';
import { blue, DismissDefault20Px, IconButton, tokens } from '@galaxy-react/core';
import { forwardRef, ReactNode, useImperativeHandle, useMemo, useState } from 'react';

type Props = DrawerProps & {
  trigger: ReactNode;
  open?: DrawerProps['open'];
  onOpenChange?: DialogProps['onOpenChange'];
};

const StyledDismiss = styled(IconButton)({
  position: 'absolute',
  top: '24px',
  right: '24px',
  cursor: 'pointer',
  zIndex: 10,
  color: blue[700],
  '&:focus-visible': {
    zIndex: 10,
  },
  '&.fui-Button': {
    '& .fui-Button__icon': {
      width: 20,
      height: 20,
    },
  },
});
export interface DrawerRef {
  close: () => void;
}
const StyledDrawer = styled(Drawer)({
  '&.fui-Drawer': {
    width: 'auto',
    borderRadius: `${tokens.spacingHorizontalNone} ${tokens.borderRadiusXLarge} ${tokens.borderRadiusXLarge} ${tokens.spacingHorizontalNone}`,
    boxShadow: '0px 8px 16px 0px rgba(0, 0, 0, 0.14)',
    backdropFilter: 'blur(30px)',
    backgroundColor: 'rgba(249, 250, 251, 0.95)',
  },
});

const LRDrawer = (props: Props, ref) => {
  useImperativeHandle(ref, () => {
    return {
      // ... your methods ...
      close: () => setOpenState(false),
    };
  }, []);
  const { open, onOpenChange, children, ...restProps } = props;
  const [openState, setOpenState] = useState<boolean>(false);
  const _open = useMemo(() => {
    if (open !== undefined) {
      return open;
    }
    return openState;
  }, [open, openState]);

  const handleOpenChange = (event, data) => {
    onOpenChange?.(event, data);
    setOpenState(data.open);
  };

  const toggleDrawer = (bool: boolean) => {
    setOpenState(bool);
    onOpenChange?.(null, {
      type: 'triggerClick',
      open: bool,
      event: null,
    });
  };

  return (
    <>
      <div onClick={() => toggleDrawer(true)}>{props?.trigger}</div>
      <StyledDrawer open={_open} onOpenChange={handleOpenChange} {...restProps}>
        <StyledDismiss
          title="Dismiss"
          appearance="transparent"
          icon={<DismissDefault20Px />}
          onClick={() => toggleDrawer(false)}
        />
        {children}
      </StyledDrawer>
    </>
  );
};

export default forwardRef<DrawerRef, Props>(LRDrawer);
